export default "__VITE_ASSET__B_01SUgI__"